import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getUnprocessedItems, getOutstandingTotal } from 'helpers/accounting';
import { BadgeAlt, Table, TableBody, TableCell, TableRow, } from '@cargomatic/ui';
import { withTranslation } from 'react-i18next';
import formatMoney from 'utils/formatters/Money';
import { Disclosure } from '@headlessui/react';
import { ChevronRight, ChevronUp } from 'lucide-react';
import { featureEnabled, CONFIGURED_FEATURES } from 'helpers/feature-flags';
class ChargeItem extends Component {
    constructor(props) {
        super(props);
        this.handleToggleExpand = () => {
            this.setState((prevState) => ({ expanded: !prevState.expanded }));
        };
        this.state = { expanded: false };
    }
    getOutstandingTotal() {
        const { ledgerType, shipment } = this.props;
        return getOutstandingTotal(shipment, ledgerType);
    }
    getFormattedTotal() {
        const amount = this.getOutstandingTotal();
        return formatMoney(amount, this.props.currency);
    }
    render() {
        const { shipment, t } = this.props;
        const missingDocsLabel = featureEnabled(CONFIGURED_FEATURES.SSR)
            ? 'MISSING_DOCS'
            : 'MISSING_POD';
        return (React.createElement(Disclosure, null, ({ open }) => (React.createElement("div", { className: "border-b last:border-b-0" },
            React.createElement(Disclosure.Button, { className: "w-full px-4 py-3 flex items-center justify-between hover:bg-muted/50 transition-colors" },
                React.createElement("div", { className: "flex items-center gap-2" },
                    React.createElement("span", { className: "font-medium text-sm" }, shipment.shipment_id),
                    shipment.missing_docs && (React.createElement(BadgeAlt, { variant: "outline", className: "bg-red-100 text-red-800 border-red-300 text-xs" }, t(missingDocsLabel)))),
                React.createElement("div", { className: "flex items-center gap-4" },
                    !open && (React.createElement("span", { className: "text-sm" }, this.getFormattedTotal())),
                    open ? (React.createElement(ChevronUp, { className: "h-4 w-4 text-muted-foreground" })) : (React.createElement(ChevronRight, { className: "h-4 w-4 text-muted-foreground" })))),
            React.createElement(Disclosure.Panel, null,
                React.createElement("div", { className: "bg-muted/30 border-t" },
                    React.createElement(Table, null,
                        React.createElement(TableBody, null,
                            getUnprocessedItems(shipment, this.props.ledgerType).map((adjustment) => (React.createElement(TableRow, { key: adjustment._id, className: "border-b-0 hover:bg-transparent" },
                                React.createElement(TableCell, { className: "py-1.5 pl-6 text-sm text-muted-foreground" }, adjustment.message),
                                React.createElement(TableCell, { className: "py-1.5 pr-6 text-sm text-right tabular-nums" }, formatMoney(adjustment.value, this.props.currency))))),
                            React.createElement(TableRow, { className: "hover:bg-transparent" },
                                React.createElement(TableCell, { className: "py-1.5 pl-6 text-sm font-medium border-t" },
                                    t('TOTAL'),
                                    ":"),
                                React.createElement(TableCell, { className: "py-1.5 pr-6 text-sm font-medium text-right tabular-nums border-t" }, this.getFormattedTotal()))))))))));
    }
}
ChargeItem.propTypes = {
    shipment: PropTypes.object,
    isEven: PropTypes.bool,
    ledgerType: PropTypes.oneOf(['receivables', 'payables']),
};
export default withTranslation()(ChargeItem);
